import { Coverage } from '@app/domain/model/Coverage';

export const determineCoverageName = (coverage: string): string => {
    switch (coverage) {
        case Coverage.CriticalIllness:
            return 'coverages.criticalIllness';
        case Coverage.LifeInsurance:
            return 'coverages.lifeInsurance';
        case Coverage.BB:
            return 'coverages.bb';
        case Coverage.CriticalIllnessExtended:
            return 'coverages.criticalIllnessExtended';
        case Coverage.CriticalIllnessInsuranceExtended:
            return 'coverages.criticalIllnessInsuranceExtended';
        case Coverage.CriticalIllnessKids:
            return 'coverages.criticalIllnessKids';
        case Coverage.CriticalIllnessKidsAdditional:
            return 'coverages.criticalIllnessKidsAdditional';
        case Coverage.CriticalIllnessMain:
            return 'coverages.criticalIllnessMain';
        case Coverage.DailySubstinenceCriticalIllnessExtended:
            return 'coverages.dailySubstinenceCriticalIllnessExtended';
        case Coverage.DailySubstinenceCriticalIllnessKids:
            return 'coverages.dailySubstinenceCriticalIllnessKids';
        case Coverage.DailySubstinenceCriticalIllnessMain:
            return 'coverages.dailySubstinenceCriticalIllnessMain';
        case Coverage.DeathByAccident:
            return 'coverages.deathByAccident';
        case Coverage.DisabilityByAccident:
            return 'coverages.disabilityByAccident';
        case Coverage.FortyOneCriticalIllnessesExtended:
            return 'coverages.fortyOneCriticalIllnessesExtended';
        case Coverage.InjuryByAccident:
            return 'coverages.injuryByAccident';
        case Coverage.InjuryByAccidentExtended:
            return 'coverages.injuryByAccidentExtended';
        case Coverage.LifeInsuranceD:
            return 'coverages.lifeInsuranceD';
        case Coverage.OncoDrop:
            return 'coverages.oncoDrop';
        case Coverage.SickPayCriticalIllnessExtended:
            return 'coverages.sickPayCriticalIllnessExtended';
        case Coverage.SickPayCriticalIllnessKids:
            return 'coverages.sickPayCriticalIllnessKids';
        case Coverage.SickPayCriticalIllnessMain:
            return 'coverages.sickPayCriticalIllnessMain';
        case Coverage.TemporaryDisabilityByAccident:
            return 'coverages.temporaryDisabilityByAccident';
        case Coverage.TotalAndPermanentDisabilityInsurance:
            return 'coverages.totalAndPermanentDisabilityInsurance';
        case Coverage.TotalAndPermanentLossOfWork:
            return 'coverages.totalAndPermanentLossOfWork';
        case Coverage.TwentyTwoCriticalIllnessKids:
            return 'coverages.twentyTwoCriticalIllnessKids';
        case Coverage.TwentyTwoCriticallIllnessKidsAdditional:
            return 'coverages.twentyTwoCriticallIllnessKidsAdditional';
        case Coverage.APD2:
            return 'coverages.apd2';
        default:
            return '';
    }
};
